import { Color } from 'root-constants'
import styled, { css } from 'styled-components'
import { IProps as IButtonProps } from './Button'

export const StyledButtonBase = css`
  width: 100%;
  max-width: 328px;
  height: 56px;
  display: block;
  margin: 40px auto 0;
  padding: 0 16px;
  cursor: pointer;
  border: none;
  outline: none;
  background: ${Color.GRADIENT};
  border-radius: 30px;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  text-decoration: none;
  text-align: center;
  color: ${Color.WHITE};
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
`

export const StyledButton = styled.button<IButtonProps>`
  ${StyledButtonBase};

  &:disabled {
    background: ${({ disabledBackgroundColor }) =>
      disabledBackgroundColor || '#898B95'};
  }
`
